(ns quuppa.peweb.outputs
  (:require [clojure.string :as str]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.universalformat.universal-target :as peweb-ut]
            [quuppa.qpe.pe.universalformat.universal-target :as ut]
            [quuppa.qsm.permissions :as permissions]
            [quuppa.ui.button :as button]
            [quuppa.qsm.site.subs :as ss]
            [re-frame.core :as rf]))

(defn output-row-button [props & children]
  (into [button/button
         (assoc props :small true)]
        children))

(defn output-row [{:keys [class target-state content]} & buttons]
  [:div.d-flex.flex-row.justify-content-between
   {:class class}
   [:div.d-flex.align-items-center
    [:div.qi-circle.mx-2
     {:class (case target-state
               :success "text-success"
               :warning "text-warning"
               :error "text-error"
               "invisible")}]

    content]
   (into [:div.btn-group.flex-shrink-0] buttons)])


(defn peinfo-outputs-data-player-target
  [{:keys [qpe-dispatch qpe-subscribe]}]
  (let [project-state @(qpe-subscribe [:qpe/project-state])
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if (:data-file-target-enabled project-state)
                      :success
                      :warning)
      :content (if (:data-file-target-enabled project-state)
                 (str "Recording to folder: " (:data-file-target-folder project-state))
                 "Not active")}
     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-resource? site-entity))
       (if (:data-file-target-enabled project-state)
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           ;; TODO: This QuuppaDataFile should be put in a def and be explained why it should be exactly this string
           :on-click #(qpe-dispatch [:qpe/control-data-player {:id "QuuppaDataFile" :enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-data-player {:id "QuuppaDataFile" :enabled true}])}
          "Start"]))]))

(defn peinfo-outputs-udp-target
  [{:keys [qpe-dispatch qpe-subscribe]}]
  (let [{enabled? :data-udp-target-enabled :as project-state} @(qpe-subscribe [:qpe/project-state])
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if enabled?
                      :success
                      :warning)
      :content (str (if enabled?
                      "Streaming to"
                      "Not active,")
                    " IP: " (:data-udp-target-ip project-state))}

     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-resource? site-entity))
       (if enabled?
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-output-target {:id "QuuppaDataUDP" :enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-output-target {:id "QuuppaDataUDP" :enabled true}])}
          "Start"]))

     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-resource? site-entity))
       (when-not enabled?
         [output-row-button
          {:variant "primary"
           :outline true
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :output-udp-target-settings
                                                          :settings {}}])}
          "Settings"]))]))

(defn peinfo-binary-logging
  [{:keys [qpe-subscribe qpe-dispatch] :as _opts}]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        binary-running? (-> controller-state :binary-logging :running)
        start (-> controller-state :binary-logging :start-time)
        start-instant (if (date-time/instant? start)
                        start
                        (date-time/native-date->instant (js/Date. start)))
        current-binary-folder (-> controller-state :binary-logging :subfolder)
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    [output-row
     {:target-state (if binary-running?
                      :success
                      :warning)
      :content (if binary-running?
                 [:span
                  (str "Running, folder: " current-binary-folder " started ")
                  [c/date-time start-instant]]
                 "Not started")}
     (when (or (permissions/has-manage-permission?)
               (permissions/has-manage-permission-to-resource? site-entity))
       (if binary-running?
         [output-row-button
          {:variant "danger"
           :attr {:type "button"}
           :on-click #(qpe-dispatch [:qpe/control-binary-logging {:enabled false}])}
          "Stop"]
         [output-row-button
          {:variant "success"
           :attr {:type "button"}
           :on-click (fn [_e]
                       (qpe-dispatch [:qpe/control-binary-logging {:enabled true}]))}
          "Start"]))]))

(defn peinfo-universal-targets
  [{:keys [target] :as target-conf} {:keys [qpe-subscribe qpe-dispatch] :as _opts}]
  (let [kw-support? (contains? @(qpe-subscribe [:qpe/data :server-info :qpe-features]) :qpe-api/universal-target-keywords)
        current-targets (vals (if kw-support?
                                @(qpe-subscribe [:qpe/data :project-state :universal-targets target])
                                ;; backwards compatibility: target was lower cased string
                                @(qpe-subscribe [:qpe/data :project-state :universal-targets (str/lower-case (name target))])))
        target-count (count current-targets)
        {:keys [project-id site-id]} @(rf/subscribe [:nav/match :parameters :path])
        site-entity (when site-id
                      @(rf/subscribe [::ss/site project-id site-id]))]
    (into
      [:<>
       [output-row
        {:content [:span.badge.bg-secondary.fs-6.fw-medium
                   "Targets "
                   [:span.badge.text-bg-dark target-count]]}
        (when (or (permissions/has-manage-permission?)
                  (permissions/has-manage-permission-to-resource? site-entity))
          [output-row-button
           {:start-icon :plus
            :attr {:type "button"}
            :on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :create-universal-target
                                                           :id target
                                                           :ut (ut/make-universal-target {:target target})
                                                           :settings (assoc target-conf :kw-support? kw-support?)}])}
           "Create target"])]]

      (for [{target-name :name, :keys [enabled MQTTScheme WebsocketScheme] :as t} current-targets]
        ;; NOTE: target's name is considered unique, it is identifier!!!
        ^{:key target-name}
        [output-row
         {:class "my-1"
          :target-state (if enabled
                          :success
                          :warning)
          :content (peweb-ut/target-row-content t)}

         (when (or (permissions/has-manage-permission?)
                   (permissions/has-manage-permission-to-resource? site-entity))
           [output-row-button
            {:variant (if enabled "danger" "success")
             :attr {:type "button"}
             :on-click #(qpe-dispatch [:qpe/control-universal-target {:name target-name
                                                                      :mode (if enabled "stop" "start")}])}
            (if enabled "Stop" "Start")])
         (when (or (permissions/has-manage-permission?)
                   (permissions/has-manage-permission-to-resource? site-entity))
           [output-row-button
            {:variant "primary"
             :outline true
             :attr {:type "button"}
             :on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :control-universal-target
                                                            :id target-name
                                                            :ut (merge
                                                                  {:name target-name}
                                                                  (when MQTTScheme
                                                                    {:MQTTScheme MQTTScheme})
                                                                  (when WebsocketScheme
                                                                    {:WebsocketScheme WebsocketScheme}))
                                                            :current (ut/make-universal-target t)
                                                            :settings (assoc target-conf :kw-support? kw-support?)}])}
            "Settings"])]))))
